export const IDENTITY_STEP_NAME = {
  AGREE: 'agree',
  START: 'start',
  OTP: 'otp',
  QUESTIONS: 'questions'
} as const;

export type IdentityStepName = typeof IDENTITY_STEP_NAME[keyof typeof IDENTITY_STEP_NAME];
